import React, { useEffect, useState } from 'react';
import './users-feedback.css';
import http from '../../services/http-service'
// import { DataGrid } from '@mui/x-data-grid';
import { ToastContainer, toast } from 'react-toastify';
import Grid from '@mui/material/Grid';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { styled, alpha } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { useHistory } from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import debounce from 'lodash.debounce';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarIcon from '@mui/icons-material/Star';
import sadEmoji from '../../assets/sad.png';
import happyEmoji from '../../assets/happy.png';
import veryHappyEmoji from '../../assets/veryHappy.png';
// import SentimentDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentDissatisfiedOutlined'; //very sad
// import MoodOutlinedIcon from '@mui/icons-material/MoodOutlined'; // Happy

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

function UsersFeedback(props) {
  const history = useHistory();
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [searchItem, setSearchItem] = useState('');
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(parseInt(props.match.params.page))

  const fetchUserFeedbackData = (value, search) => {
    if (value)
      setCurrentPage(value)
    else
      setCurrentPage(1)

    let params = {
      page: value,
      search: search
    }
    handleToggle()
    http('employer/user_given_feedback_list/', 'GET', '', params)
      .then(res => {
        if (res.status) {
          setCount(0)
          setCount(Math.ceil(res.data.count / res.data.page_size))
          res.data.results.forEach(elem => {
            var services = elem.services.map(function (item) {
              return item[0];
            });
            elem.services = services.toString()
          })
          setTableData(res.data.results)
        }
        else {
          toast.error(res.message,{
            toastId: "toastId2"
          })
        }
        handleClose()
      },
        err => {
          handleClose()
          console.log('err....', err)
        })
  }

  const handleSearch = debounce((value) => {
    setSearchItem(value)
    setCurrentPage(1)
    history.push('/users-feedback/' + 1)
    fetchUserFeedbackData(1, value)
  }, 1000)

  useEffect(() => {
    fetchUserFeedbackData(currentPage, searchItem);
    // eslint-disable-next-line
  }, []);

  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  const handleChangePage = (event, page) => {
    history.push('/users-feedback/' + page);
    fetchUserFeedbackData(page, searchItem)
  }

  return (
    <div className="mainAppDiv">
      <ToastContainer />
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <div className='employeeHeading_row'>
        <div className='employeeHeading'> Users Feedback </div>
        <Grid item lg={4} className='upsearchGrid'>
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase onChange={(e) => {

              handleSearch(e.target.value)
            }}
              placeholder="Search…"
              inputProps={{ 'aria-label': 'search' }}
            />
          </Search>
        </Grid>
      </div>
      {
        tableData.length > 0 ? (
          <div>
            <div className='customTable'>
              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Employee Id</th>
                    <th>Employer Id</th>
                    <th>Rating</th>
                    <th>Message</th>
                    <th>Emoji</th>
                    <th>Service</th>
                  </tr>
                </thead>
                <tbody>

                  {tableData.map((data, index) => (
                    <tr key={index}>
                      <td key={'first_name' + index}>{data.name}</td>
                      <td key={'employee_id' + index}>{data.employee_id}</td>
                      <td key={'employer_id' + index}>{data.employer_id}</td>
                      <td key={'rating' + index}>
                        {data.rating === 5 ? <div><StarIcon /> <StarIcon /> <StarIcon /> <StarIcon /> <StarIcon /></div> : ""}
                        {data.rating === 4 ? <div><StarIcon /> <StarIcon /> <StarIcon /> <StarIcon /> <StarOutlineIcon /></div> : ""}
                        {data.rating === 3 ? <div><StarIcon /> <StarIcon /> <StarIcon /> <StarOutlineIcon /> <StarOutlineIcon /></div> : ""}
                        {data.rating === 2 ? <div><StarIcon /> <StarIcon /> <StarOutlineIcon /> <StarOutlineIcon /> <StarOutlineIcon /></div> : ""}
                        {data.rating === 1 ? <div><StarIcon /> <StarOutlineIcon /> <StarOutlineIcon /> <StarOutlineIcon /> <StarOutlineIcon /></div> : ""}
                      </td>
                      <td key={'message' + index}>{data.message}</td>
                      <td key={'emoji' + index}>
                        {
                          data.emoji === 'happy' ? (
                            <img src={happyEmoji} alt="happy"/>
                            // <span style={{ fontSize: '30px' }}>&#128522;</span>
                          ) : (
                            data.emoji === 'sad' ? 
                            // <span style={{ fontSize: '30px' }}>&#128542;</span> 
                            <img src={sadEmoji} alt="sad"/>
                            : <img src={veryHappyEmoji} alt="happy"/>
                            // <span style={{ 'font-size': '30px' }}>&#128518;</span>
                          )
                        }


                      </td>
                      <td key={'service' + index}>{data.services}</td>
                    </tr>
                  ))}


                </tbody>
              </table>

            </div>
            <Stack spacing={2} className="employeePagination">
              <Pagination count={count} color="primary" page={currentPage} onChange={handleChangePage} />
            </Stack>
          </div>

        ) : (
          <div className='recordNotFoundDiv'>
            <h2>Records Not Found</h2>
          </div>
        )
      }

    </div>
  )
}

export default UsersFeedback;
